import { render } from "./VposHome.vue?vue&type=template&id=72d0ce37"
import script from "./VposHome.vue?vue&type=script&lang=js"
export * from "./VposHome.vue?vue&type=script&lang=js"

import "./VposHome.vue?vue&type=style&index=0&id=72d0ce37&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__